// ============================================================
// ARKISION AI — Mock content (will be replaced by backend later)
// ============================================================

export const navLinks = [
  { label: "Platform", href: "/#platform" },
  { label: "Capabilities", href: "/#capabilities" },
  { label: "Industries", href: "/industries/healthcare" },
  { label: "Impact", href: "/#impact" },
  { label: "Why Arkision", href: "/#why-us" },
];

export const heroStats = [
  { value: "24/7", label: "Autonomous voice support" },
  { value: "55+", label: "Languages & regional dialects" },
  { value: "100+", label: "Concurrent patient calls" },
  { value: "94%", label: "Patient satisfaction score" },
];

export const tickerItems = [
  "Serving GCC & Global Markets",
  "Local Support · Global Standards",
  "Smarter Conversations. Healthier Tomorrow.",
  "Better Access · Faster Support · Happier Patients",
  "Data Stays in Your Country",
  "HIS / EMR Ready",
];

// ---------- Interactive demo (mock conversation) ----------
export const demoScript = [
  { speaker: "agent", lang: "Arabic", text: "مرحباً! شكراً لاتصالك بمستشفى المدينة. كيف يمكنني مساعدتك اليوم؟", en: "Hello! Thank you for calling City Hospital. How can I help you today?" },
  { speaker: "patient", lang: "English", text: "I would like to book an appointment with a cardiologist." },
  { speaker: "agent", lang: "English", text: "Of course. Dr. Ahmed Khan has availability this week. Would Thursday at 10:00 AM work for you?" },
  { speaker: "patient", lang: "Hindi", text: "जी हाँ, गुरुवार सुबह 10 बजे ठीक है।", en: "Yes, Thursday 10 AM works for me." },
  { speaker: "agent", lang: "English", text: "Perfect. Your appointment is confirmed with Dr. Ahmed Khan, Cardiology, Thursday 10:00 AM. A WhatsApp confirmation is on its way." },
];

// ---------- Advanced capabilities (AI workforce) ----------
export const capabilities = [
  {
    icon: "Wrench",
    title: "Custom Tool Executions",
    desc: "Connect agents to any hospital API — update the HIS, create tickets, send emails or trigger workflows mid-call.",
    visual: "tools",
  },
  {
    icon: "BarChart3",
    title: "Comprehensive Insights",
    desc: "Real-time call performance dashboards, sentiment analysis, transcripts and booking conversion tracking.",
    visual: "insights",
  },
  {
    icon: "BookOpen",
    title: "Dynamic Knowledge Base",
    desc: "Agents continuously learn from your documents, protocols and website to give accurate, up-to-date answers.",
    visual: "knowledge",
  },
  {
    icon: "ArrowLeftRight",
    title: "Seamless Call Routing",
    desc: "Effortlessly route calls to your PABX / internal telephony system, or escalate sensitive calls to a human agent with the full conversation context.",
    visual: "handoff",
  },
  {
    icon: "Clock",
    title: "24/7 Autonomous Operation",
    desc: "Your agents work around the clock — never miss a patient call, appointment request or urgent query again.",
    visual: "always",
  },
  {
    icon: "Languages",
    title: "Multilingual Support",
    desc: "Engage every patient in their native language — 15+ international languages and 40+ regional dialects.",
    visual: "multilingual",
  },
];

// ---------- Healthcare value-adds (from pitch deck) ----------
export const valueAdds = [
  {
    id: "appointment-management",
    icon: "CalendarCheck",
    title: "Appointment Management",
    tagline: "Book · Reschedule · Cancel — over a simple phone call",
    desc: "The AI agent handles the complete scheduling journey: doctor selection, availability check, booking confirmation and instant WhatsApp confirmation.",
    bullets: ["Hospital doctors & departments directory", "Calendar scheduling & live slots", "AI scheduling engine", "Automated booking confirmations"],
  },
  {
    id: "call-concurrency",
    icon: "PhoneCall",
    title: "Call Concurrency",
    tagline: "Scale as your hospital grows",
    desc: "Handle 15 concurrent calls by default and scale the limit instantly as call volumes grow — no busy tones, no missed patients.",
    bullets: ["Flexible scaling on demand", "Reliable performance at peak hours", "Cloud infrastructure", "Optimized for healthcare"],
  },
  {
    id: "multilingual",
    icon: "Languages",
    title: "Multi-Language Patient Communication",
    tagline: "15+ international languages · 40+ regional dialects",
    desc: "Serve international patients in the language they are most comfortable with — with mid-call language switching.",
    bullets: ["Arabic, English, Hindi, Urdu, Tamil, Bengali & more", "AI voice assistant with natural accents", "Real-time language switching", "Built for diverse patient populations"],
  },
  {
    id: "dashboards",
    icon: "LayoutDashboard",
    title: "Different Dashboards for Different Roles",
    tagline: "Right information. Right people. Better decisions.",
    desc: "Every role sees exactly what they need — from CEO-level strategy to receptionist daily assistance.",
    bullets: ["Role-based access control", "Customizable views", "Real-time updates", "Secure, compliant & accessible on any device"],
  },
  {
    id: "analytics",
    icon: "LineChart",
    title: "Call Analytics",
    tagline: "Better insights. Better decisions.",
    desc: "Track every call: volume trends, outcomes, department performance and patient sentiment in one live view.",
    bullets: ["More answered calls", "Higher booking conversion", "Happier patients", "Better operational efficiency"],
  },
  {
    id: "live-tracking",
    icon: "Radar",
    title: "Live Appointment Tracking",
    tagline: "Real-time visibility across the patient journey",
    desc: "Follow every appointment from booking to completion — live queues, check-ins and consultation status on one operations dashboard.",
    bullets: ["Real-time visibility", "Better resource utilization", "Smoother patient flow", "Higher efficiency"],
  },
  {
    id: "campaigns",
    icon: "Megaphone",
    title: "Social Media Campaigning",
    tagline: "Right message. Right patient. Right time.",
    desc: "Fetch contacts from your HMS, create health campaigns, send them via WhatsApp and amplify on social media.",
    bullets: ["Disease prevention drives", "New technology announcements", "Health camps & blood donation", "Higher patient engagement"],
  },
  {
    id: "integrations",
    icon: "Blocks",
    title: "Hospital System Integrations",
    tagline: "One AI patient-engagement layer across your stack",
    desc: "Arkision plugs into your existing hospital systems — HMS, EMR, billing, doctor scheduling, payment gateways, WhatsApp and PABX/telephony.",
    bullets: ["Secure data flow", "Seamless integration", "Higher efficiency", "Better patient experience"],
  },
  {
    id: "data-residency",
    icon: "ShieldCheck",
    title: "Your Data Stays in Your Country",
    tagline: "Your data stays in KSA. Our AI works for you.",
    desc: "Patient records, billing, insurance and medical information remain inside the Kingdom — in your private cloud or on-premises — with minimized exposure to external systems.",
    bullets: ["Hospital controlled", "Regulatory compliant", "Secure infrastructure", "24/7 patient support"],
  },
];

export const appointmentSteps = [
  { step: 1, title: "Patient Call", desc: "Patient calls — the AI assistant answers instantly." },
  { step: 2, title: "Doctor Selection", desc: "Agent suggests the right specialty & doctor." },
  { step: 3, title: "Availability Check", desc: "Live calendar slots checked in real time." },
  { step: 4, title: "Booking Confirmation", desc: "Slot booked & confirmed in the HMS." },
  { step: 5, title: "WhatsApp Confirmation", desc: "Instant confirmation & reminders on WhatsApp." },
];

export const concurrencyTiers = [
  { size: "Small Clinic", recommended: "5 – 10" },
  { size: "50 – 100 Bed Hospital", recommended: "10 – 20" },
  { size: "200 – 500 Bed Hospital", recommended: "20 – 50" },
  { size: "Multi-Hospital Group", recommended: "50 – 100" },
];

export const internationalLanguages = [
  "Arabic", "English", "Hindi", "Urdu", "French", "Bengali", "Tamil", "Tagalog",
  "Malayalam", "Telugu", "Spanish", "Turkish", "Persian", "Indonesian", "Pashto",
];

export const regionalLanguages = [
  "Kannada", "Punjabi", "Gujarati", "Marathi", "Nepali", "Sinhala", "Malay", "Swahili",
  "Bhojpuri", "Rajasthani", "Odia", "Assamese", "Sindhi", "Kashmiri", "Tulu", "Konkani",
  "Maithili", "Haryanvi", "Marwari", "Awadhi", "Chhattisgarhi", "Magahi", "Bundelkhandi",
  "Garhwali", "Kumaoni", "Dogri", "Manipuri", "Bodo", "Santali", "Najdi Arabic", "Hejazi Arabic",
  "Egyptian Arabic", "Levantine Arabic", "Gulf Arabic", "Yemeni Arabic", "Sudanese Arabic",
  "Amharic", "Somali", "Hausa", "Yoruba", "Wolof",
];

export const languageSamples = [
  { lang: "Arabic", text: "كيف يمكنني حجز موعد؟", font: "arabic" },
  { lang: "Hindi", text: "मुझे डॉक्टर से मिलने का समय चाहिए।", font: "default" },
  { lang: "English", text: "I would like to book an appointment.", font: "default" },
  { lang: "Urdu", text: "میں اپائنٹمنٹ بک کرانا چاہتا ہوں۔", font: "arabic" },
  { lang: "Tamil", text: "நான் ஒரு சந்திப்பை பதிவு செய்ய விரும்புகிறேன்.", font: "default" },
  { lang: "French", text: "Je voudrais prendre rendez-vous.", font: "default" },
];

// ---------- Role dashboards ----------
export const dashboardRoles = [
  {
    role: "CEO",
    focus: "Strategic Overview",
    metrics: [
      { label: "Total Patients", value: "2,456", trend: "+12%" },
      { label: "Appointments", value: "1,893", trend: "+9%" },
      { label: "Patient Satisfaction", value: "96%", trend: "+5%" },
    ],
    highlights: ["Hospital performance at a glance", "Patient trends & top services", "Revenue-linked insights"],
  },
  {
    role: "Duty Manager",
    focus: "Real-time Operations",
    metrics: [
      { label: "Live Calls", value: "12", trend: "now" },
      { label: "Appointments Today", value: "248", trend: "+6" },
      { label: "Pending Follow-ups", value: "14", trend: "-3" },
    ],
    highlights: ["Today's schedule by room", "Live queue monitoring", "Escalation alerts"],
  },
  {
    role: "Admin Staff",
    focus: "Patient & Staff Management",
    metrics: [
      { label: "Patient Records", value: "4,892", trend: "" },
      { label: "Appointments", value: "1,893", trend: "" },
      { label: "Messages", value: "356", trend: "" },
    ],
    highlights: ["Patient records & profiles", "Bulk messaging & reports", "Staff task management"],
  },
  {
    role: "Doctor",
    focus: "Patient Care Insights",
    metrics: [
      { label: "My Patients Today", value: "12", trend: "" },
      { label: "Follow-ups", value: "5", trend: "" },
      { label: "Avg. Consult Time", value: "14m", trend: "" },
    ],
    highlights: ["Recent patient interactions", "Consultation history", "Care-gap reminders"],
  },
  {
    role: "Receptionist",
    focus: "Daily Assistance",
    metrics: [
      { label: "New Appointments", value: "32", trend: "" },
      { label: "Patient Calls", value: "57", trend: "" },
      { label: "Walk-ins", value: "18", trend: "" },
    ],
    highlights: ["One-click booking view", "Message inbox", "Walk-in coordination"],
  },
];

export const analyticsStats = [
  { label: "Incoming Calls", value: "2,843", trend: "+12%", up: true },
  { label: "Answered Calls", value: "2,531", trend: "+15%", up: true },
  { label: "Missed Calls Eliminated", value: "412", trend: "+28%", up: true },
  { label: "Avg. Call Duration", value: "3m 42s", trend: "-18%", up: false },
  { label: "Booking Conversion", value: "68%", trend: "+22%", up: true },
  { label: "Patient Satisfaction", value: "94%", trend: "+8%", up: true },
];

export const departmentPerformance = [
  { dept: "Cardiology", pct: 92 },
  { dept: "Orthopedics", pct: 88 },
  { dept: "Pediatrics", pct: 85 },
  { dept: "Dermatology", pct: 78 },
  { dept: "General Medicine", pct: 72 },
];

export const trackingFlow = ["Book", "Confirm", "Check-in", "Consult", "Complete"];

export const liveQueue = [
  { name: "Aisha Khan", dept: "Cardiology", wait: "In 5 min", status: "Next" },
  { name: "Ravi Patel", dept: "Internal Medicine", wait: "In 12 min", status: "Queued" },
  { name: "Maria Gomez", dept: "Pediatrics", wait: "In 18 min", status: "Queued" },
  { name: "Ahmed Ali", dept: "Orthopedics", wait: "In 24 min", status: "Queued" },
];

export const campaignSteps = [
  { step: 1, title: "HMS Contact Fetch", desc: "Patient contacts, appointment data & profiles pulled securely from your HMS." },
  { step: 2, title: "Create Campaign", desc: "Compose awareness or outreach campaigns in minutes." },
  { step: 3, title: "Send via WhatsApp", desc: "Deliver messages directly to patient WhatsApp numbers." },
  { step: 4, title: "Connect on Social Media", desc: "Amplify the campaign across Facebook & Instagram." },
];

export const campaignTypes = ["Disease Prevention", "New Technology", "Health Camps", "Blood Donation"];

export const integrationSystems = [
  { name: "HMS", icon: "Building2" },
  { name: "EMR", icon: "FileHeart" },
  { name: "Billing System", icon: "Receipt" },
  { name: "Doctor Scheduling", icon: "CalendarClock" },
  { name: "Payment Gateway", icon: "CreditCard" },
  { name: "WhatsApp", icon: "MessageCircle" },
  { name: "PABX / Telephony", icon: "Phone" },
];

export const residencyLayers = [
  { name: "Hospital Database", location: "Inside KSA" },
  { name: "Saudi HMS", location: "Inside KSA" },
  { name: "Saudi Private Cloud / On-Premises", location: "Inside KSA" },
  { name: "Arkision Middleware", location: "Inside KSA" },
  { name: "AI Layer — Conversation Processing", location: "Inside KSA or isolated" },
];

export const residencyPoints = [
  "Patient records stay in-country",
  "Billing & insurance data stays in-country",
  "Medical information never leaves your premises",
  "Minimized exposure to external systems",
  "Regulatory compliant & hospital controlled",
];

// ---------- Business impact ----------
export const businessImpacts = [
  { icon: "CalendarPlus", title: "More Appointments", metric: "+32%", desc: "Every call answered means more bookings captured — even after hours." },
  { icon: "UserMinus", title: "Lower Reception Workload", metric: "-60%", desc: "Routine calls, FAQs and bookings automated so staff focus on in-person care." },
  { icon: "HeartHandshake", title: "Better Patient Experience", metric: "94%", desc: "Instant answers in the patient's own language drive satisfaction scores." },
  { icon: "TrendingUp", title: "Scalable Operations", metric: "100+", desc: "Concurrent calls scale with your growth — from clinic to hospital group." },
  { icon: "CalendarX", title: "Reduced No-Shows", metric: "-45%", desc: "Automated WhatsApp reminders and easy rescheduling keep slots filled." },
];

// ---------- Why us comparison matrix ----------
export const comparisonRows = [
  { capability: "Healthcare-Specific Expertise", arkision: "Purpose-built for Hospitals & Clinics", gcc: "Multi-industry", global: "Generic Platform" },
  { capability: "HMS / EMR Integration", arkision: "Custom Integration", gcc: "Limited", global: "Requires Custom Development" },
  { capability: "Appointment Booking Workflow", arkision: "End-to-End", gcc: "Basic", global: "Basic" },
  { capability: "WhatsApp Patient Journey", arkision: "Confirmations, Reminders, Follow-ups", gcc: "Limited", global: "Add-on Required" },
  { capability: "Preventive Care Campaigns", arkision: "Available", gcc: "Limited", global: "Not Standard" },
  { capability: "Custom Workflow Development", arkision: "Fully Customizable", gcc: "Moderate", global: "Template-Based" },
  { capability: "Data Residency Options", arkision: "Flexible Architecture", gcc: "Available", global: "Often External Cloud" },
  { capability: "Integration with Existing PBX/SIP", arkision: "Supported", gcc: "Limited", global: "Limited" },
  { capability: "AI Receptionist", arkision: "Advanced", gcc: "Available", global: "Available" },
  { capability: "Outbound Patient Engagement", arkision: "Available", gcc: "Limited", global: "Limited" },
  { capability: "Hospital Workflow Automation", arkision: "Core Focus", gcc: "Not Core Focus", global: "Not Core Focus" },
  { capability: "Custom Reporting & Dashboards", arkision: "Customizable", gcc: "Standard", global: "Standard" },
  { capability: "GCC Localization", arkision: "High", gcc: "High", global: "Medium" },
];

// ---------- Contact ----------
export const liveDemoUrl =
  "https://agent.retellai.com/orb/agent_5d36d83e17f7653ccd1844ab9e?token=f81469eb4e211c6d4dccf060ee36d22d";

export const trustedBrands = [
  "Sunrise Hospital",
  "Al Noor Medical Center",
  "City National Hospital",
  "Crescent Care Clinics",
  "Meridian Health Group",
  "Oasis Specialist Hospital",
  "Vitalis Medical Institute",
  "Harmony Children's Hospital",
];

export const contactInfo = {
  gccPartner: {
    name: "Arkision AI — GCC Office",
    partner: "Hail Towers EST.",
    role: "Local Partner & Support in GCC",
    address: "Quraish Business Center, Quraish, Al-Bawadi, Jeddah 23531, Kingdom of Saudi Arabia",
    email: "intezar@hailtowers.com",
    phone: "+966 50 466 1923",
    website: "www.hailtowers.com",
  },
  indiaOffice: {
    name: "Arkision AI — India Office",
    address: "Second Floor, BIMTECH Campus, Plot No - 5, Knowledge Park 2, Greater Noida, U.P, 201306",
    email: "support@arkision.com",
    phone: "+91 8960969291",
  },
  arkision: {
    email: "support@arkision.com",
    tagline: "Smarter Conversations. Healthier Tomorrow.",
  },
};
